(() => {
  if (customElements.get('subcategory-slider')) {
    return;
  }

  class subcategorySlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.sliderOptions = {};
      this.collectionWrapper = document.querySelector('.collection-wrapper');
      this.heroSubheading = document.querySelector('.collection-hero__subheading');
      this.isTextOnly = this.classList.contains('slider__no-images');
      this.nextButton = this.querySelector('.subarrow.subright');
     
    }

    connectedCallback() {
      this.initSlider();
      this.collectionClasses();
      this.setupButtonListeners();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.sliderOptions = {
        slidesPerView: 2.5,
        spaceBetween: 5,
        breakpoints: {
          990: {
            slidesPerView: 4,
            spaceBetween: 18,
          },
          1200: {
            slidesPerView: 6,
            spaceBetween: 18,
          },
        },
      };

      if (this.isTextOnly) {
        this.sliderOptions.slidesPerView = 'auto';
        this.sliderOptions.spaceBetween = 25;
        this.sliderOptions.breakpoints = {};
      }

      this.slider = new Swiper(this.querySelector('[data-slider]'), this.sliderOptions);
    }

    collectionClasses() {
      if (this.collectionWrapper) {
        this.collectionWrapper.classList.add('collection-wrapper--hascategory');
      };

      if (this.heroSubheading) {
        this.heroSubheading.classList.add('collection-hero__subheading--hascategory');
        if (this.heroSubheading && this.heroSubheading.textContent.trim() !== '') {
          this.heroSubheading.style.paddingTop = '0px';
          document.querySelector('.collection-hero__wrapper.banner_image_enable .collection-hero__content').style.paddingBottom = '0px';
        }
      };
    }
    setupButtonListeners() {
      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.handleNextButtonClick.bind(this));
      }
    }
    handleNextButtonClick() {
      if (this.slider) {
        this.slider.slideNext();
      }
    }
  }

  customElements.define('subcategory-slider', subcategorySlider);
})();
